export const DEFAULT_STALE_TIME_MS = 1000 * 60 * 5

